<template>
  <div class="footer">
    <div class="page_body_title otherProductTitle">
      其他产品推荐
    </div>
    <div class="page_body_content ">
      <div class="page_body_content_box_otherProducts" @click="everbrightBank">
        <div>
          <img src="@/assets/images/guangda.png" alt="" class="guangda fl" />
          <div class="bankMiddle">
            <p class="bankGd">光大银行信用卡</p>
            <p class="specialits">
              <span class="space">白金信用卡</span>
              <span class="space paddingLeft4 paddingRight4">最高10万</span>
              <span class="paddingLeft4">8项专项服务</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {};
  },
  methods: {
    everbrightBank() {
      const jumpCreditCardAddress = 'https://xyk.cebbank.com/cebmms/apply/ps/card-detail.htm?card_id=3341&pro_code=FHTG105318SA0003ZHYT&c2c_recom_flag=';
      this.$api.LoanSupermarket.encapsulationAxios().then(() => {
        window.location.href = jumpCreditCardAddress;
      });
    },
  },
};
</script>
<style scoped>
p {
  margin: 0;
}
.paddingLeft4 {
  padding-left: 4px;
}
.paddingRight {
  padding-right: 4px;
}
.page_body_content_box_otherProducts {
  width: 100%;
  height: 120px;
  background-color: #fff;
  box-sizing: border-box;
  padding-left: 14px;
}
.page_body_title {
  color: #1c2438;
  padding-left: 16px;
  padding-right: 18px;
  font-size: 17px;
  font-weight: 600;
  width: 100%;
  height: 50px;
  background-color: #fff;
  box-sizing: border-box;
  line-height: 50px;
  text-align: left;
}
.otherProductTitle {
  border-bottom: 1px solid #f5f5f5;
}
.guangda {
  width: 73px;
  display: block;
  padding-top: 31px;
  float: left;
}
.bankMiddle {
  padding-top: 22px;
  padding-left: 100px;
}
.bankMiddle .bankGd {
  font-size: 14px;
  color: #1c2438;
  letter-spacing: 0;
  font-weight: 600;
  text-align: left;
}
.specialits {
  font-size: 13px;
  color: #b7bfd2;
  text-align: left;
  margin-top: 4px;
}
.space {
  border-right: 3px solid #e6e8ef;
  padding-right: 4px;
}
</style>
